export default "__VITE_ASSET__CeB$n9zf__"